export const ScrollBarConfig = `
::-webkit-scrollbar {
    width: 9px;
  }
  

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #f5f5f5;
    border-radius: 10px;
    opacity: 0.3;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #f5f5f5;
  }
`;